import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Stack,
} from "@mui/material";
import { IconX, IconHistory } from "@tabler/icons-react";
import ContractStatusHistory from "./ContractStatusHistory";

const ContractStatusHistoryModal = ({ 
  open, 
  onClose, 
  contract 
}) => {
  if (!contract) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="lg" 
      fullWidth
      PaperProps={{
        sx: { minHeight: '600px' }
      }}
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconHistory size={24} />
            <Typography variant="h6" component="div">
              Histórico de Status
            </Typography>
          </Stack>
          <IconButton onClick={onClose} size="small">
            <IconX />
          </IconButton>
        </Stack>
        
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          Contrato: <strong>{contract.number || `#${contract.id}`}</strong> | 
          Cliente: <strong>{contract.customer?.name}</strong> | 
          Banco: <strong>{contract.bank?.name}</strong>
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <ContractStatusHistory contractId={contract.id} />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContractStatusHistoryModal;